// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  language_default: 'it',
  second_title: ' | DM Manufacturing',
  password_min_length: 8,
  api: {
    base_url : "/api/v1"
  },
  websocket: {
    broadcast_channel: "xrsupport-channel"
  },
  home_page: '/documents',
  avatar_url: '/assets/images/users/user-img.jpg',
  file_accepted_files: [
    'application/pdf',
    'image/jpeg',
    'image/png',
  ],
  aveScreenshotOnServer: true,
  saveLocallyScreenshot: false,
  language_list: [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Italiano',
      code: 'it',
      icon: '/assets/images/flag/icon-flag-it.svg',
    },
    {
      language: 'Deutsch',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ]
};
